import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { View, ScrollView } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import { Accordion, AccordionItem } from '@dbk/ui-accordion'
import { FormattedMessage } from '@dbk-legacy/format';
// import { H1 } from '@dbk/ui-text';
import { Tabs, Tab } from '@dbk/ui-tabs';
import 'moment/min/locales';
import Text, { Large } from '@dbk/ui-text';
import TableRow from '../../../../../../src/components/common/table-row';
import { PAGE, CUSTOM_REPORT_SELECTED_RANGE } from '../constants';
import CalendarModal from '../../../../../../src/components/common/calendar-modal';
import { ChangeIndicatedCurrency, ChangeIndicatedAbbreviatedNumber } from '../../../../../../src/components/common/number';
import { CorrectPagination as Pagination } from '../../../../../../src/components/common/pagination';
import format from 'date-fns/format';
import getPaginatedItems from '../../../../../../src/utils/get-paginated-items';
import SimpleDate from '../../../../../../src/components/common/date';
import styles from '../../../../../../src/screens/reports/transaction-history/transaction-history.styles';
import additionalStyles from './report-custom-transaction-history.style';
import { AccordionPlusIcon, AccordionMinusIcon } from '../../../../../../src/components/common/icons';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import moment from 'moment';
import { BasicNumber } from '@dbk/ui-numbers';
import Button from '@dbk/ui-buttons';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import InverseProvider from '@dbk/ui-inverse';
import { formatDate } from '../report-utils';

// let languageCode = 'en';
const today = moment().format('YYYY-MM-DD');
const weekAgo = moment().subtract(6, 'd').format('YYYY-MM-DD');
const monthAgo = moment().subtract(30, 'd').format('YYYY-MM-DD');
const trimonthAgo = moment().subtract(3, 'months').format('YYYY-MM-DD');
const currentDate = moment();
// const before3MonthsDate = moment().subtract(3, 'months');

class TransactionHistory extends PureComponent {

  constructor(props) {
    super(props);
    const languageCode = this.props.auth.langCode;
    Utils.configLocale(languageCode, {
      week: {
        dow: 1, // Monday is the first day of the week.
        // dow: 0, // Sunday is the first day of the week.
      },
    });
    this.state = {
      timeline: 0,
      // currentYear: new Date().getFullYear(),
      // lastYear: new Date().getFullYear() - 1,
      fromDate: 'date',
      toDate: 'date',
      selectedTab: 0,
      pageOffset: 0,
      activeItems: [],
      currentTab: 0,
      downloadType: '',
      dateApplied: false,
      value: {
        from: moment().subtract(3, 'months'),
        to: moment()
      },
    };

    this.props.setStartDate(weekAgo);
    this.props.setEndDate(today);

    // Utils.configLocale(languageCode, {
    //   week: {
    //     dow: 1, // Monday is the first day of the week.
    //     // dow: 0, // Sunday is the first day of the week.
    //   },
    // });
  }

  componentDidMount() {

    this.props.getTransactionDetails();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.reports.custom.downloads.result !== nextProps.reports.custom.downloads.result) {
      const result = nextProps.reports.custom.downloads.result;
      this.excelDownload(
        this.jsonToXml(result),
        result.sheetname ? result.sheetname : this.state.downloadType + '.xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    this.props.setTransactionHistoryList([]);
  }

  componentDidUpdate(){
    if (this.props.reports.closeDatePicker === true && this.datepickerRef && this.datepickerRef.datepicker && this.datepickerRef.datepicker.state && this.datepickerRef.datepicker.state.isOpen ) {
      this.onCancel();
    }
  }

  excelDownload(content, filename, contentType) {
    if (!contentType) contentType = 'application/octet-stream';
    const anchor = document.createElement('a');
    const blob = new Blob([content], {
      type: contentType,
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
      anchor.download = filename;
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  jsonToXml(jsonObject) {
    let row;
    var col;
    let xml;
    const arrData =
      typeof jsonObject !== 'object' ? JSON.parse(jsonObject) : jsonObject;

    xml = this.createXmlHeader(arrData);

    for (const rowData in arrData.sections) {
      for (
        let resultsLength = 0;
        resultsLength < arrData.sections[rowData].results.length;
        resultsLength++
      ) {
        xml += '<ss:Row>\n';
        for (var col in arrData.sections[rowData].results[resultsLength]) {
          xml += '  <ss:Cell>\n';
          xml += '    <ss:Data ss:Type="String">';
          xml +=
            arrData.sections[rowData].results[resultsLength][col] +
            '</ss:Data>\n';
          xml += '  </ss:Cell>\n';
        }
        xml += '</ss:Row>\n';
      }
    }
    xml += this.createXmlFooter();
    return xml;
  }

  createXmlHeader(arrData) {
    let headerRow = '<ss:Row>\n';
    let dataRow = '';

    for (const preRow in arrData.sections) {
      dataRow +=
        '<ss:Row>' +
        '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
        arrData.sections[preRow].name +
        '</ss:Data>' +
        '</ss:Cell>' +
        '</ss:Row>\n' +
        '<ss:Row>' +
        '<ss:Cell ss:StyleID="xls-style-1"><ss:Data ss:Type="String">' +
        arrData.sections[preRow].description +
        '</ss:Data>' +
        '</ss:Cell>' +
        '</ss:Row>\n';
      for (const index in arrData.sections[preRow].headers) {
        headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
        headerRow += '    <ss:Data ss:Type="String">';
        headerRow += arrData.sections[preRow].headers[index] + '</ss:Data>\n';
        headerRow += '  </ss:Cell >\n';
      }
    }

    headerRow += '</ss:Row>\n';
    return (
      '<?xml version="1.0"?>\n' +
      '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
      '<ss:Styles>\n' +
      '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
      '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
      '<ss:Borders>\n' +
      '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '</ss:Borders>\n' +
      '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
      '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
      '</ss:Style>\n' +
      '</ss:Styles>\n' +
      '<ss:Worksheet ss:Name="Sheet1">\n' +
      '<ss:Table>\n' +
      dataRow +
      '<ss:Row/>\n' +
      headerRow
    );
  }

  createXmlFooter() {
    return '</ss:Table>\n' + '</ss:Worksheet>\n' + '</ss:Workbook>\n';
  }

  setPageOffset = newOffset => {
    this.setState({ pageOffset: newOffset });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  onSelectTime(selectedTab) {
    const { setStartDate, setEndDate, getTransactionDetails, setTransactionHistoryList, setTransSelectedTab } = this.props;
    this.setState({
      selectedTab,
      pageOffset: 0,
    });
    setTransSelectedTab(selectedTab);
    setTransactionHistoryList(undefined);
    if (selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM) {
      setStartDate(trimonthAgo);
      setEndDate(today);
      this.handlePaginationChange();
      return;
    }

    switch (selectedTab) {
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_WEEK:
        setStartDate(weekAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.LAST_MONTH:
        setStartDate(monthAgo);
        break;
      case CUSTOM_REPORT_SELECTED_RANGE.PAST_THREE_MONTHS:
        setStartDate(trimonthAgo);
        break;
      default:
        break;
    }
    setEndDate(today);
    getTransactionDetails();
    this.handlePaginationChange();
  }

  _renderHeader(row) {
    return (
      <View>
        <TableRow>
          <TableRow.Column align="left" width={0.33} >
            <Text>
              <SimpleDate value={row.tradeDate} />
              {format(new Date(row.tradeDate), 'DD MMM YYYY')}
            </Text>
          </TableRow.Column >
          <TableRow.Column align="left" width={0.33}>
            <Text>
              {row.tranTypeDesc}
            </Text>
          </TableRow.Column>
          <TableRow.Column align="right" width={0.33}>
            <Text style={styles.currencyText}>{row.ccyTrade}</Text>
            <Text align='right' style={{ color: '#fff' }}>
              <ChangeIndicatedAbbreviatedNumber
                renderProps={{ size: 'normal' }}
                value={parseFloat(row.netAmtTradeCcy)}
                // maxDigits={7}
                renderExactAs="currency"
                onlyNegativeStyling
              />
            </Text>
          </TableRow.Column>
        </TableRow>
      </View>
    );
  }

  _renderContentFlex(row) {
    const { i18n: { messages }, } = this.props;
    const { qty, portfolioId, ccyTrade, transactionNo, price, pfCurr } = row;
    return (
      <View style={{ flexDirection: 'column', marginTop: 25, marginBottom: 25 }}>
        <View style={{ flexDirection: 'row', width: '100%' }}>
          <View style={additionalStyles.accordionMain}>
            <Text style={{ color: '#a7a8aa' }} primary>{messages['app.chedelivery.reports.customReports.txn.portfolio']}</Text>
          </View>
          <View style={additionalStyles.accordionMain}>
            <Text style={{ color: '#a7a8aa' }} primary>{messages['app.chedelivery.reports.customReports.txn.reference']}</Text>
          </View>
          <View style={additionalStyles.accordionMainNumber}>
            <Text style={{ color: '#a7a8aa' }} primary>{messages['app.report.transactionHistory.quantity']}</Text>
            <View style={additionalStyles.accordionCollapseNumber}>
              {/* {(qty === null || qty === undefined) ?
              <Text secondary>-</Text> : this.num2text(qty, true)} */}
            </View>
          </View>
          <View style={additionalStyles.accordionMainLast}>
            <Text style={{ color: '#a7a8aa' }} primary>{<FormattedMessage
              id={'app.chedelivery.reports.customReports.txn.price'}
              values={{ currency: ccyTrade }} />}</Text>
            <View style={additionalStyles.accordionCollapseLast}>
              {/* {(price === null || price === undefined) ?
              <Text secondary>-</Text> : this.num2text(price)} */}
            </View>
          </View>
        </View>

        <View style={{ flexDirection: 'row', width: '100%' }}>
          <View id="text_report_portfolio_customTransactionHistory_test" style={additionalStyles.accordionCollapse}>
            <Text secondary> {portfolioId} {pfCurr} </Text>
          </View>
          <View id="text_report_number_customTransactionHistory_test" style={additionalStyles.accordionCollapse}>
            <Text secondary>{transactionNo} </Text>
          </View>
          <View id="text_report_qty_customTransactionHistory_test" style={additionalStyles.accordionCollapseNumber}>
            {(qty === null || qty === undefined) ?
              <Text secondary>-</Text> : this.num2text(qty, true)}
          </View>
          <View id="text_report_price_customTransactionHistory_test" style={additionalStyles.accordionCollapseLast}>
            {(price === null || price === undefined) ?
              <Text secondary>-</Text> : this.num2text(price)}
          </View>
        </View>
      </View>
    )
  }

  addSign = num => num > 0 ? '+' + num : num;
  num2text = (num, addSign = false, digit = 2) => (
    <BasicNumber
      value={num}
      notANumberComponent={<Text secondary>-</Text>}
      addPlusSign={addSign}
    >
      {
        (text) => (<Text style={{ color: 'white' }}>{text.formattedValue}</Text>)
      }
    </BasicNumber >
  )

  /** '#ec6b10' */
  _renderContent(row) {
    const { i18n: { messages }, } = this.props;
    const { qty, portfolioId, ccyTrade, transactionNo, price } = row;
    return (
      <View>
        <View style={styles.seperator}>
          <View style={styles.maginTableRow}>
            <TableRow>
              <TableRow.Column style={{
                borderRight: 1,
                borderRightColor: '#ffffff', margin: 20
              }} align="left" >
                <Text>
                  <Text>{messages['app.chedelivery.reports.customReports.txn.portfolio']}</Text>
                </Text>
              </TableRow.Column>
              <TableRow.Column align="left">
                <Text>
                  <Text>{messages['app.chedelivery.reports.customReports.txn.reference']}</Text>
                </Text>
              </TableRow.Column>
              <TableRow.Column align="left">
                <Text>{messages['app.report.transactionHistory.quantity']}</Text>
              </TableRow.Column>
              <TableRow.Column align="left">
                <Text>{messages['app.chedelivery.reports.customReports.txn.price']}</Text>
              </TableRow.Column>

            </TableRow>
            <TableRow>
              <TableRow.Column align="left">
                <Text secondary>
                  {portfolioId}
                </Text>
              </TableRow.Column>
              <TableRow.Column align="left">
                <Text secondary>
                  {transactionNo}
                </Text>
              </TableRow.Column>
              <TableRow.Column align="left">
                <Text secondary>{qty.toLocaleString()}</Text>
              </TableRow.Column>
              <TableRow.Column align="right">
                <Text secondary>
                  {price}
                </Text>
              </TableRow.Column>
            </TableRow>
          </View>
        </View>
      </View>
    );
  }

  handleChange = activeItems => {
    this.setState(
      {
        activeItems,
      },
      () => {
        if (this.props.rememberState && this.props.state.setExpandedItem) {
          const [rowId] = activeItems;
          if (rowId) {
            this.props.state.setExpandedItem(rowId);
          }
        }
      }
    );
  };

  /* renderRowHeaderFlex(row){
   const { i18n: { messages }, } = this.props;
   const { tradeDate, tranTypeDesc, securityLongName, ccyTrade, netAmtTradeCcy } = row;
  return(

       <div className="columns small-centered medium-centered large-centered">
         <View style={{ flexDirection: 'row', flex: 1, height: 35 }}>
           <View style={{ width: '20%' }}>
             <Text value={tradeDate} style={{ color: '#ffffff', fontWeight: 'bold', fontSize: 16 }}>{format(tradeDate, 'DD MMM YYYY')}</Text>
           </View>

           <View style={{ width: '45%' }}>
             <Text>{tranTypeDesc}</Text>
           </View>

           <View style={{ width: '30%', alignItems: "flex-end", marginRight: 30 }}>
             <Text >
               {netAmtTradeCcy === null ? "-" :
                 <ChangeIndicatedCurrency
                   value={parseFloat(netAmtTradeCcy)}
                   renderProps={{ size: 'medium' }}
                   currency={ccyTrade}
                   onlyNegativeStyling />}
             </Text>
           </View>

         </View>
         <View style={{ flexDirection: 'row', flex: 1, height: 30 }}>
           <Text>{securityLongName}</Text>
         </View>

  </div>
  );
  } */

  renderRowHeaderFlex(row) {
    const {
      i18n: { messages },
      auth: { langCode }
    } = this.props
    const { tradeDate, tranTypeDesc, securityLongName, ccyTrade, netAmtTradeCcy } = row;
    return (
      <div >
        {/* className="columns small-centered medium-centered large-centered"> */}
        <View style={{ flex: 1, width: '90%', height: '60px', flexDirection: 'column', justifyContent: 'center' }}>
          <View style={{ flexDirection: 'row', flex: 1 }}>
            <View style={{ width: '27%' }}>
              <Text testID="text_date_reportCustomTransactionHistory_test" value={tradeDate} style={{ color: '#ffffff', fontWeight: 'bold', fontSize: 14 }}>
                {formatDate(tradeDate, langCode)}
              </Text>
            </View>
            <View style={{ width: '28%', color: '#a7a8aa' }}>
              <Text style={{ color: '#a7a8aa', fontSize: 14 }}>{tranTypeDesc}</Text>
            </View>
            <View style={{ width: '45%' }}>
              <Text style={{ textAlign: 'right' }}>
                {netAmtTradeCcy === null || ccyTrade === null || ccyTrade === ""? (
                  '-'
                ) : (

                    <ChangeIndicatedCurrency
                      value={parseFloat(netAmtTradeCcy)}
                      renderProps={{ size: 16, color: '#fff' }}
                      currency={ccyTrade}
                      onlyNegativeStyling
                    />
                  )}
              </Text>
            </View>
          </View>
          <View Style={{ flexDirection: 'row', flex: 1 }}>
            <Text style={{ color: '#a7a8aa', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
              numberOfLines={1} ellipsizeMode={'tail'}>{securityLongName}</Text>
          </View>
        </View>
      </div>
    )
  }

  renderRowHeader(row) {
    const {
      i18n: { messages },
    } = this.props
    const { tradeDate, tranTypeDesc, securityLongName, ccyTrade, netAmtTradeCcy } = row
    return (
      <View>
        <View style={styles.seperator}>
          <View style={styles.maginTableRow}>
            <TableRow style={{ marginRight: '45px', marginBottom: '20px' }}>
              <TableRow.Column align="left">
                <Text style={{ color: '#ffffff', fontWeight: 'bold' }}>
                  <SimpleDate value={tradeDate} />
                </Text>
              </TableRow.Column>
              <TableRow.Column align="left">
                <Text>{tranTypeDesc}</Text>
              </TableRow.Column>
              <TableRow.Column align="right">
                <Text>
                  {netAmtTradeCcy === null ? (
                    '-'
                  ) : (
                      <ChangeIndicatedCurrency
                        value={parseFloat(netAmtTradeCcy)}
                        renderProps={{ size: 'small' }}
                        currency={ccyTrade}
                        onlyNegativeStyling
                      />
                    )}
                </Text>
              </TableRow.Column>
            </TableRow>

            <TableRow style={{ marginBottom: "20px" }}>
              <TableRow.Column align="left">
                <Text>
                  {securityLongName}
                </Text>
              </TableRow.Column>
            </TableRow>
          </View>
        </View>
      </View>);
  }

  renderRows(rows) {
    return rows.map((row, index) => (
      <AccordionItem
        itemKey={index}
        key={index}
        className="ReportDocListAccordionItems customReportAccrd"
        renderTitle={() => this.renderRowHeaderFlex(row)}
      >
        {this._renderContentFlex(row)}
      </AccordionItem>
    ));
  }


  callDirectExcelService(trxType) {
    this.setState({ isLoading: true });
    const {
      reports: { trans: { startDate, endDate } },
    } = this.props;
    this.setState({ downloadType: trxType });
    this.props
      .downLoadReport({
        reportname: trxType,
        fromDate: startDate,
        toDate: endDate
      })
      .then((success) => {
        this.setState({ isLoading: false });
      }).catch((error) => {
        this.setState({ isLoading: false });
      });
  }

  handlePaginationChange = () => {
    this.setState({
      activeItems: [],
    });
    this.rootView.scrollTo({ y: 0 });
  }

  /*  onChangeRange = range => {
      this.setState({
        dateRange: false,
        range,
      })

    } */

  onDayClick = (selectionStart) => {
    const value = Utils.addDayToRange(
      selectionStart,
      this.state.value
    );
    this.setState({
      value,
    });
  };

  onChangeRange = (range) => {
    this.setState({
      value: {
        ...Utils.updateRangeWithReset(this.state.value, range)
      }
    });
  }

  onApplyDateChange = () => {
    // this.setState({dateApplied: true});
    this.props.getCustomDateRangeData(this.state.value.from, this.state.value.to);
    this.props.setCustomStartDate(this.state.value.from.format('YYYY-MM-DD'));
    this.props.setCustomEndDate(this.state.value.to.format('YYYY-MM-DD'));
    this.onCancel();
    // this.setState({dateApplied: false});
  }


  onCancel = () => {
    this.datepickerRef.datepicker.closeCalendar();
    this.props.setDatePickerClose(false);
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
      <div className='datepicker-footer-txt'>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className='datepicker-footer-btn'>
        <Button tertiary
          onClick={() => this.onCancel()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
        disabled={!(this.state.value.from && this.state.value.to)}
          onClick={() => this.onApplyDateChange()}
        >{messages['app.chedelivery.reports.apply']}</Button>
      </div>
    </InverseProvider>
  }

  render() {
    const {
      i18n: { messages },
      reports: { transactions: { showSpinner },
        trans: { transactionHistoryList, isLoading } },
      auth : {documentDownloadDisabled}
    } = this.props;
    let transactions = [];
    const { selectedTab, pageOffset, activeItems } = this.state;
    const pageSize = PAGE.pageSize;
    let paginatedTransactions = [];

    // if (this.props.auth.langCode && this.props.auth.langCode != null) {
    //   languageCode = this.props.auth.langCode.toLowerCase();
    // }

    if (transactionHistoryList && transactionHistoryList.length > 0) {
      transactions = transactionHistoryList;
      paginatedTransactions = getPaginatedItems(transactions, pageOffset, pageSize);
    }
    /** {
      !screen.isSmall ? stickyHeader = <StickyHeaderTablet messages={messages} />
        : stickyHeader = <StickyHeader messages={messages} />
    }* */
    return (
      <View style={styles.container}>
        <div>

          <View style={{ marginLeft: 20, marginRight: 20 }}>
            <Tabs
              secondary
              stretch
              handleSelectedIndex={index => this.onSelectTime(index)}
              selectedIndex={selectedTab}
            >
              <Tab tabIndex={0} testID="tab_report_7days_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => <div tabIndex={0}>{messages['app.incomehistory.7days']}</div>} />
              <Tab testID="tab_report_30days_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => <div tabIndex={-1}>{messages['app.report.transactionHistory.30days']}</div>} />
              <Tab testID="tab_report_3months_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => <div tabIndex={-1}>{messages['app.report.transactionHistory.3months']}</div>} />
              <Tab testID="tab_report_date_reportCustomTransactionHistory_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => <div tabIndex={0}>{messages['app.maturities.overview.tabs.labels.custom']}</div>} />
            </Tabs>
          </View>

          <SortingHeader
            enabled={false}
            showBorder={false}
            messages={messages}
          />

          {selectedTab === CUSTOM_REPORT_SELECTED_RANGE.CUSTOM &&
            <div className="customReportCalendar"
              style={{
                height: "65px", width: "50%",
                flexDirection: "row", alignItems: 'center', justifyContent: 'flex-end', margin: "20px 20px 15px 0px", float: "right"
              }}>
              <View id="datepicker_reports_reportCustomTransactionHistory_test" style={{
                border: "solid", borderWidth: "1px", borderRadius: "3px", borderColor: '#a7a8aa',
                margin: "20px 20px 15px 15px", width: '300px', float: 'right'
              }}>
                <DatePicker
                  ref={(ref) => this.datepickerRef = ref}
                  showOutsideMonthDays={false}
                  canChangeMonth
                  enableYearNavigation
                  enableRangeSelection
                  onChange={this.onChangeRange}
                  value={this.state.value}
                  startDate={moment().subtract(3, 'months')}
                  endDate={moment()}
                  inputDateFormat={'DD MMM YYYY'}
                  selectionStart={this.state.value.from}
                  selectionEnd={this.state.value.to}
                  renderFooter={() => this.customFooter()}
                />
              </View>
            </div>
          }
        </div>

        <View style={{ clear: 'both', marginLeft: 7, marginRight: 17 }}>
          {
            <View>
              {isLoading || showSpinner === true ?
                <View><LoadingCircle /></View>
                :

                <div id="container_reports_reportCustomTransactionHistory_test" className="scrollBarHover" style={{ width: '100%' }}>
                  <ScrollView
                    className="scrollBarHide" id="scrollBarHide"
                    ref={r => this.rootView = r}
                    style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "500px" }}
                  >{paginatedTransactions.length > 0 ?
                    <Accordion
                      activeItems={this.state.activeItems}
                      testID="list"
                      allowMultiple={false}
                      onChange={this.handleChange}
                      inverse
                      renderIconForOpen={() => <AccordionMinusIcon color={'#d37130'} />}
                      renderIconForClose={() => <AccordionPlusIcon />}
                    >
                      {this.renderRows(paginatedTransactions)}
                    </Accordion>
                    :
                    (transactionHistoryList !== undefined) ?
                      <div className="text-center margin-top-20">
                        <Large secondary> {messages['app.reports.noRecords']}</Large>
                      </div>
                      :
                      (transactionHistoryList !== undefined) ?
                        <div className="text-center margin-top-20">
                          <Large secondary> {messages['app.reports.noRecords']}</Large>
                        </div>
                        :
                        <div style={{ minHeight: '470px', position: "relative" }} />
                    }
                  </ScrollView>
                </div>
              }
            </View>
          }
          {(!isLoading || showSpinner) && <Pagination
            pageOffset={pageOffset}
            pageSize={pageSize}
            totalRecords={transactions.length}
            setPageOffset={this.setPageOffset}
            onPageChange={this.handlePaginationChange}
            style={{ marginVertical: 20 }} />}

        </View>


        {isLoading ? <View /> :
          <div className='btn-change-reports-container' align='right' style={{ marginRight: 20, marginTop: 20 }}>
            <div className='btn-reports-width'>
              {(paginatedTransactions && paginatedTransactions.length > 0) && 
              <Button
                testID="btn_report_reportCustomTransactionHistory_test"
                size='large'
                loading={!!this.state.isLoading}
                disabled = {documentDownloadDisabled}
                tertiary = {documentDownloadDisabled}
                style={{ marginRight: "0" }}
                onClick={() => this.callDirectExcelService('Transaction')}
              >{messages['app.chedelivery.reports.customReports.downloadButton']}</Button>}
            </div>
          </div>}
      </View>
    );
  }
}

TransactionHistory.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  trans: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getTransactionDetails: {
      $call: 'reports.trans.getTransactionDetails'
    },
    downloads: {
      calendar: {
        open: {
          $call: 'open',
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      isDateBarClickable: true,
      setFalse: { $set: 'isDateBarClickable' },
      setStartDateEmpty: { $set: 'startDate' },
      setEndDateEmpty: { $set: 'endDate' },
      // downLoadReport: {$call: 'excelData' },
      result: true,
    },

    downLoadReport: { $call: 'reports.custom.downloads.excelData' },
    reports: {
      // calendar: {
      //   open: {
      //     $call: 'open'
      //   },
      //   ...CalendarModal.getFragment('calendarModal'),
      // },
      transactions: {
        showSpinner: true
      },
      custom: {
        downloads: {
          result: true
        },
        startDate: true,
        endDate: true,
      },
      trans: {
        calendar: {
          open: {
            $call: 'open'
          },
          ...CalendarModal.getFragment('calendarModal'),
        },
        startDate: true,
        endDate: true,
        dateDisplay: true,
        transactionHistoryList: true,
        isLoading: true,
        customSelectedTab: true
      },
      closeDatePicker:true
    },
    getCustomDateRangeData: {
      $call: 'reports.trans.getSelectedRangeDataForCustomReport'
    },
    setTransactionHistoryData: {
      $call: 'reports.trans.setTransactionDetails'
    },
    setRange7Days: {
      $call: 'reports.trans.setRange7Days'
    },
    setRange30Days: {
      $call: 'reports.trans.setRange30Days'
    },
    setRange3Months: {
      $call: 'reports.trans.setRange3Months'
    },
    setRangeYTD: {
      $call: 'reports.trans.setRangeYTD'
    },
    setTransactionHistoryList: {
      $set: 'reports.trans.transactionHistoryList'
    },
    setTransSelectedTab: {
      $set: 'reports.trans.customSelectedTab'
    },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        }
      },
    },
    screen: {
      height: true,
      width: true,
      isSmall: true,
    },
    auth: {
      langCode: true,
      documentDownloadDisabled: true,
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
    setStartDate: { $set: 'reports.trans.startDate' },
    setEndDate: { $set: 'reports.trans.endDate' },
    setCustomStartDate: { $set: 'reports.custom.startDate' },
    setCustomEndDate: { $set: 'reports.custom.endDate' },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
  },
}, ({ app, ...queries }) => ({
  ...queries,
  deviceInfo: app.global.deviceInfo,
}))(TransactionHistory);

export { TransactionHistory };